import { useQuery } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { BankCharacter } from "@/domains/bank/types";

export const QUERY_KEY_BANK_CHARACTER = "bank-character";

export function useBankCharacterQuery({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [QUERY_KEY_BANK_CHARACTER],
    queryFn: async () => {
      const response = await BankMpProvider.getBankCharacter();

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.message);
      }

      return response.data;
    },
    select: (data) =>
      ({
        id: data.id,
        accountNumber: data.accountNumber,
        hasBankAccount: data.accountNumber !== "",
        balance: data.card,
        cash: data.cash,
        nextTariffPayment: data.nextTariffPayment,
        tariff: {
          id: data.tariffId,
          name: data.tariff.name,
          cardStyleAsset: data.tariff.cardStyleAsset,
          withdrawalLimit: data.tariff.withdrawalLimit,
          transferLimit: data.tariff.transferLimit,
          withdrawalFeePercent: data.tariff.withdrawalFeePercent,
          transferFeePercent: data.tariff.transferFeePercent,
          price: data.tariff.price,
        },
        limit: data.limit,
      }) satisfies BankCharacter,
    enabled,
  });
}
